import React from 'react';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const InvitePopup = (props) => {
    const { bonusSharedEmail, bonusSharedFb, bonusSharedTelegram, bonusSharedViber, bonusSharedWhatsapp } = usePageMessages();

    const {
        bonusBalance: { mailToSubject, sharedLink, sharedText },
    } = useExtra();

    const hidePopup = () => props.popupRef.current?.close();

    return (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            <PopupButton href={`mailto:?subject=${mailToSubject}&body=${sharedText}`} iconName="mail" text={bonusSharedEmail} onClick={hidePopup} />
            <PopupButton
                target="_blank"
                href={`https://facebook.com/sharer/sharer.php?u=${sharedLink}`}
                iconName="facebook"
                text={bonusSharedFb}
                onClick={hidePopup}
            />
            <PopupButton
                target="_blank"
                href={`https://telegram.me/share/url?url=${sharedLink}&text=${sharedText}`}
                iconName="telegram"
                text={bonusSharedTelegram}
                onClick={hidePopup}
            />
            <PopupButton target="_blank" href={`viber://forward?text=${sharedLink}`} iconName="viber" text={bonusSharedViber} onClick={hidePopup} />
            <PopupButton
                target="_blank"
                href={`https://api.whatsapp.com/send?text=${sharedText}`}
                iconName="whatsapp"
                text={bonusSharedWhatsapp}
                onClick={hidePopup}
            />
        </SimplePopup>
    );
};

export default InvitePopup;
